// extracted by mini-css-extract-plugin
module.exports = {"pageHeading":"styles_pageHeading__Dfy2U","content":"styles_content__iU0XQ"};